import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCardHeader = styled((props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <CardHeader classes={{ title: 'title', subheader: 'subheading' }} {...props} />
))`
  & .title {
    font-size: 18;
    font-weight: 400;
  }
  & .subheading {
    color: red;
  }
`;

const FormGroup = (props) => {
  const {
    heading, subheading, children,
  } = props;
  return (
    <Card
      sx={{
        width: '100%',
        boxShadow: 'none',
        paddingBottom: '25px',
      }}
    >
      {
        heading && (
          <StyledCardHeader
            className="mt2 reset-margin pa3 bg-near-white"
            title={heading}
            subheader={subheading}
          />
        )
      }
      {children}
    </Card>
  );
};

FormGroup.propTypes = {
  heading: PropTypes.node,
  subheading: PropTypes.node,
  children: PropTypes.node.isRequired,
};

FormGroup.defaultProps = {
  heading: undefined,
  subheading: undefined,
};

export default FormGroup;
